<template>
  <div class="main-box main-min-height">
    <div class="table-box bgffffff">
      <div>
        <el-form :model="searchForm" size="mini" label-width="50px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="10">
              <el-form-item prop="ip" label="IP">
                <el-input style="width:100%" v-model="searchForm.ip" clearable placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label-width="0px">
                <el-button type="primary" @click="app">
                  添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="id" label="id" align="center" width="80">
        </el-table-column>
        <el-table-column align="center" prop="ip" label="IP">
        </el-table-column>
        <el-table-column align="center" prop="joinType" label="加入方式">
          <template slot-scope="{row}">
            {{row.joinType==1?'人为加入':row.joinType==2?'系统自动加入':'未知来源'}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间">
        </el-table-column>
      </el-table>
      <Pagination location='left' :page='page' @getData="getInfo" />
    </div>
    <Dialogs v-model="dialogEditVisible" :center='true' :title='title' :HeaderPosition='true' width-dial="400px" :height-dial="50" @dialog="submit">
      <el-form size='mini' :model="ruleForm" :rules="rules" ref="ruleForm" label-position='right' label-width="50px">
        <el-form-item prop="ip" label="IP">
          <el-input v-model="ruleForm.ip" style="width:100%" placeholder="-请输入-" />
        </el-form-item>
      </el-form>
    </Dialogs>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
import Dialogs from '@/components/DiaLogs'
export default {
  name: 'Blacklist',
  components: { Pagination,Dialogs },
  data() {
    return {
      searchForm: {
        ip: null, //用户名
      },//查询条件
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      tableData: [],//表格参数
      dialogEditVisible: false,
      ruleForm: {
        ip: null,
      },
      rules: {
        ip: [
          { required: true, message: '请输入IP', trigger: 'blur' }
        ],
      },
      title: '新增黑名单IP',
    };
  },
  computed: {},
  mounted() {
    this.getInfo();
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$System.queryAllBlacklist(
        {
          ...this.searchForm,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    //打开弹窗
    app(){
        this.ruleForm.ip = null,
        this.dialogEditVisible = true
    },
    //提交
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$System.joinBlacklist({ ...this.ruleForm }).then(({ data }) => {
            if (data.code === 200) {
              this.messages(data.message, true, 1000, () => {
                this.getInfo();
                this.dialogEditVisible = false
              })
            }
          })
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.y_color {
  color: #ff702e;
}
.lv_color {
  color: #0acd5e;
}
</style>
